import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2df20e1a&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=2df20e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df20e1a",
  null
  
)

export default component.exports